import type { CounterOfferFormattedReasonsGroup } from '~/scopes/buyback/pages/orderDetails/components/OrderOnHoldModal/counterOfferReasonsGroupsAdapter'

export const filterPreselectedReasons = (
  groups: CounterOfferFormattedReasonsGroup[],
): string[] => {
  return groups.reduce<string[]>((acc, group) => {
    const selectedReasons = group.reasons
      .filter(({ checked }) => checked === true)
      .map(({ id }) => id)

    return [...acc, ...selectedReasons]
  }, [])
}
